// extracted by mini-css-extract-plugin
module.exports = {"consentText":"ConsentText_consentText__loJ4C","link":"ConsentText_link__5mbF9"};